<div class="mi-applicant-details-fields" id="mi-applicant-details-fields">

  <form [formGroup]="applicantDetailsForm" autocomplete="off">
    <div class="row d-flex flex-column flex-md-row  ">
      <mc-form-field-wrapper class="col-xs-12 col-md-4" [label]="applicantText?.idNum" [fieldId]="'mi-applicant-id'"
        [control]="getFormControl('userId')" [customErrorMessages]="customErrorMessages">
        <mc-input-text [id]="'mi-applicant-id'" [ariaLabelledBy]="'mi-applicant-id'" formControlName="userId"
          [inputType]="'tel'">
        </mc-input-text>
        @if(!isInvalidAndTouchedUserId){
        <div class="d-flex">
          <i class="d-none d-sm-block icon-alert-circle mc-mt-1 mc-me-1"></i>
          <span> {{applicantText?.idNumRemark}}</span>
        </div>
        }
      </mc-form-field-wrapper>

      <mc-form-field-wrapper class="col-xs-12 col-md-4" [label]="applicantText?.firstName"
        [customErrorMessages]="customErrorMessages" [fieldId]="'mi-applicant-first-name'"
        [control]="getFormControl('firstName')">
        <mc-input-text [id]="'mi-applicant-first-name'" [ariaLabelledBy]="'mi-applicant-first-name'"
          formControlName="firstName">
        </mc-input-text>
      </mc-form-field-wrapper>

      <mc-form-field-wrapper class="col-xs-12 col-md-4" [label]="applicantText?.lastName"
        [customErrorMessages]="customErrorMessages" [fieldId]="'mi-applicant-last-name'"
        [control]="getFormControl('lastName')">
        <mc-input-text [id]="'mi-applicant-last-name'" [ariaLabelledBy]="'mi-applicant-last-name'"
          formControlName="lastName">
        </mc-input-text>
      </mc-form-field-wrapper>

    </div>
    <span class="mi-header d-none d-sm-block my-3">{{applicantText?.communicationDetails.title}}</span>

    <div class="row d-flex flex-column flex-md-row  ">
      <mc-form-field-wrapper class="col-xs-12 col-md-4" [label]="applicantText?.communicationDetails.mobile"
        [customErrorMessages]="customErrorMessages" [fieldId]="'mi-applicant-mobile'"
        [control]="getFormControl('mobile')" [tooltipText]="applicantText?.communicationDetails.mobileTooltip">
        <mc-input-text [id]="'mi-applicant-mobile'" [ariaLabelledBy]="'mi-applicant-mobile'" formControlName="mobile"
          [inputType]="'tel'">
        </mc-input-text>
      </mc-form-field-wrapper>
      <mc-form-field-wrapper class="col-xs-12 col-md-4" [label]="applicantText?.communicationDetails.email"
        [customErrorMessages]="customErrorMessages" [fieldId]="'mi-applicant-email'"
        [tooltipText]="applicantText?.communicationDetails.emailTooltip" [control]="getFormControl('email')">
        <mc-input-text [id]="'mi-applicant-email'" [ariaLabelledBy]="'mi-applicant-email'" formControlName="email"
          [inputType]="'email'">
        </mc-input-text>
      </mc-form-field-wrapper>


    </div>
    <span class="mi-header d-none d-sm-block my-3">{{applicantText?.address.title}}</span>

    <div class="row d-flex flex-column flex-md-row  ">
      <mc-city-street-lists [form]="applicantDetailsForm" [cityControlId]="'mi-applicant-city'"
        [streetControlId]="'mi-applicant-street'" [customErrorMessages]="customErrorMessages">
      </mc-city-street-lists>

    </div>

    <div class="row d-flex flex-column flex-md-row  ">
      <mc-form-field-wrapper class="col-xs-12 col-md-4" [label]="applicantText?.address.homeNumber"
        [customErrorMessages]="customErrorMessages" [fieldId]="'mi-applicant-homeNumber'"
        [control]="getFormControl('homeNumber')">
        <mc-input-text [id]="'mi-applicant-homeNumber'" [ariaLabelledBy]="'mi-applicant-homeNumber'"
          formControlName="homeNumber">
        </mc-input-text>
      </mc-form-field-wrapper>

      <mc-form-field-wrapper class="col-xs-12 col-md-4" [label]="applicantText?.address.postalCode"
        [customErrorMessages]="customErrorMessages" [fieldId]="'mi-applicant-postalCode'"
        [control]="getFormControl('postalCode')">
        <mc-input-text [id]="'mi-applicant-postalCode'" [ariaLabelledBy]="'mi-applicant-postalCode'"
          formControlName="postalCode" [inputType]="'tel'">
        </mc-input-text>
      </mc-form-field-wrapper>
    </div>

    <div class="row d-flex flex-column flex-md-row  ">
      <mc-form-field-wrapper class="col-xs-12 col-md-4" [label]="applicantText?.isPackageYours"
        [customErrorMessages]="customErrorMessages" [fieldId]="'mi-applicant-isPackageYours'"
        [control]="getFormControl('isPackageYours')">
        <mc-radio-button-group name="mi-isPackageYours-id" [isRadioBool]="true"
          [formControl]="getFormControl('isPackageYours')" [direction]="'row'">
        </mc-radio-button-group>
      </mc-form-field-wrapper>
    </div>


    @if(showPackageNumberField){
    <span class="mi-header  mt-3 d-block">{{applicantText?.powerOfAttorneyTitle}}</span>

    <div [formGroup]="getFormGroup('packageOwnerGroup')">
      <div class="row d-flex flex-column flex-md-row  ">
        <mc-form-field-wrapper class="col-xs-12 col-md-4" [label]="applicantText?.idNum"
          [customErrorMessages]="customErrorMessages" [fieldId]="'mi-packageOwner-id'"
          [control]="getFormControl('packageOwnerGroup.packageOwnerId')">
          <mc-input-text [id]="'mi-packageOwner-id'" [ariaLabelledBy]="'mi-packageOwner-id'"
            formControlName="packageOwnerId" [inputType]="'tel'">
          </mc-input-text>
          @if(!isInvalidAndTouchedPackageOwnerId){
          <div class="d-flex">
            <i class="d-none d-sm-block icon-alert-circle mc-mt-1 mc-me-1"></i>
            <span> {{applicantText?.idNumRemark}}</span>
          </div>
          }
        </mc-form-field-wrapper>

        <mc-form-field-wrapper class="col-xs-12 col-md-4" [label]="applicantText?.firstName"
          [customErrorMessages]="customErrorMessages" [fieldId]="'mi-packageOwner-first-name'"
          [control]="getFormControl('packageOwnerGroup.packageOwnerFirstName')">
          <mc-input-text [id]="'mi-packageOwner-first-name'" [ariaLabelledBy]="'mi-packageOwner-first-name'"
            formControlName="packageOwnerFirstName">
          </mc-input-text>
        </mc-form-field-wrapper>

        <mc-form-field-wrapper class="col-xs-12 col-md-4" [label]="applicantText?.lastName"
          [customErrorMessages]="customErrorMessages" [fieldId]="'mi-packageOwner-last-name'"
          [control]="getFormControl('packageOwnerGroup.packageOwnerLastName')">
          <mc-input-text [id]="'mi-packageOwner-last-name'" [ariaLabelledBy]="'mi-packageOwner-last-name'"
            formControlName="packageOwnerLastName">
          </mc-input-text>
        </mc-form-field-wrapper>

      </div>
      <div class="row d-flex flex-column flex-md-row  ">

        <mc-form-field-wrapper class="col-xs-12 col-md-4" [label]="applicantText?.communicationDetails.mobile"
          [customErrorMessages]="customErrorMessages" [fieldId]="'mi-packageOwner-mobile'"
          [control]="getFormControl('packageOwnerGroup.packageOwnerMobile')"
          [tooltipText]="'מידע ועדכונים לבקשה ישלחו למספר זה'">
          <mc-input-text [id]="'mi-packageOwner-mobile'" [ariaLabelledBy]="'mi-packageOwner-mobile'"
            formControlName="packageOwnerMobile" [inputType]="'tel'">
          </mc-input-text>
        </mc-form-field-wrapper>

        <mc-form-field-wrapper class="col-xs-12 col-md-4" [label]="applicantText?.communicationDetails.email"
          [customErrorMessages]="customErrorMessages" [fieldId]="'mi-packageOwner-email'"
          [control]="getFormControl('packageOwnerGroup.packageOwnerEmail')"
          [tooltipText]="'מידע ועדכונים לבקשה ישלחו לכתובת זו'">
          <mc-input-text [id]="'mi-packageOwner-email'" [ariaLabelledBy]="'mi-packageOwner-email'"
            formControlName="packageOwnerEmail" [inputType]="'email'">
          </mc-input-text>
        </mc-form-field-wrapper>


      </div>

      <div class="row d-flex flex-column flex-md-row  ">

        <mc-info level="info" class="col-12  mc-mt-4">
          <div class="d-flex  flex-column ">
            <span class="fw-medium">{{applicantText?.powerOfAttorneyInfo}}</span>
          </div>
        </mc-info>




      </div>
    </div>
    }


  </form>
</div>